<template>
  <LayoutDefault>
    <div class="banner">
      <h2 class="banner__title">Баннеры на главной странице</h2>
      <div class="banner__list">
        <draggable
          v-model="bannersData"
          class="banner__list-item"
          @change="moveBanners"
        >
          <template #item="{element}">
            <BannerUploaderItem
              @delete="deleteBanner(element.Id)"
              :urlBanner="element?.BannerFiles[0]?.FilePath"
              @click="getCurrentBanner(element)"
            />
          </template>
        </draggable>
        <div class="adder">
          <ToolbarIcons
            @click="showItems"
          />
          <div
            :class="{
              'adder__items': true,
              'adder__items_visible': visibleItems
            }"
          >
            <BaseBtn
              white
              text="Изображение"
              @clickBtn="openCloseLoader(true)"
            />
            <!-- <BaseBtn
              white
              text="Видео"
              @clickBtn="openCloseLoader(true)"
            /> -->
          </div>
        </div>
      </div>

      <div class="banner__preview">
        <BannerUploaderItem
          :title="title"
          :description="description"
          :visibleDescription="visibleDescriptionPrewiew"
          bigPicture
          :urlBanner="currentBanner"
        />
      </div>

      <h2 class="banner__title">Редактирование</h2>
      <div class="banner__editor">
        <InputText
          v-model="title"
          @input="showDescriptionPrewiew"
          type="text"
          placeholder="Заголовок"
          :disabled="!currentBanner"
        />
        <Textarea
          v-model="description"
          @input="showDescriptionPrewiew"
          rows="1"
          cols="30"
          placeholder="Краткое описание"
          :auto-resize="true"
          :disabled="!currentBanner"
        />
        <InputText
          v-model="link"
          type="text"
          placeholder="Ссылка"
          :disabled="!currentBanner"
        />
      </div>
    </div>

    <div class="buttons">
      <BaseBtn
        text="Сохранить"
        @clickBtn="saveForms"
      />
      <BaseBtn
        text="Отменить"
        @clickBtn="closeBannersEditor"
      />
    </div>

    <BaseModalWindow
      @closeModal="clearLoadBanners"
      v-if="showLoaderBanners"
      :header="false"
    >
      <div class="image-uploader" v-if="!loaderVideo">
        <div class="image-uploader__item">
          <p class="image-uploader__item-name">Декстоп (1920x477 px)</p>
          <div class="card flex justify-content-center">
            <FileUpload
              mode="basic"
              name="file"
              accept="image/*"
              :url="`${envUrlBase}/api/Banner/LoadImage/1`" @before-send="authToken" :auto="false" chooseLabel="Добавить"
            />
          </div>
        </div>

        <div class="image-uploader__item">
          <p class="image-uploader__item-name">Планшет (вертикальная версия, 1200x356  px)</p>
          <div class="card flex justify-content-center">
            <FileUpload
              mode="basic"
              name="file"
              :url="`${envUrlBase}/api/Banner/LoadImage/2`" accept="image/*"
              @before-send="authToken"
              :auto="false"
              chooseLabel="Добавить"
            />
          </div>
        </div>

        <div class="image-uploader__item">
          <p class="image-uploader__item-name">Планшет (горизонтальная версия, 960x356 px)</p>
          <div class="card flex justify-content-center">
            <FileUpload
              mode="basic"
              name="file"
              :url="`${envUrlBase}/api/Banner/LoadImage/3`" accept="image/*"
              @before-send="authToken"
              :auto="false"
              chooseLabel="Добавить"
            />
          </div>
        </div>

        <div class="image-uploader__item">
          <p class="image-uploader__item-name">Мобильная версия (вертикальная версия, 640x400 px)</p>
          <div class="card flex justify-content-center">
            <FileUpload
              mode="basic"
              name="file"
              :url="`${envUrlBase}/api/Banner/LoadImage/4`" accept="image/*"
              @before-send="authToken"
              :auto="false"
              chooseLabel="Добавить"
            />
          </div>
        </div>

        <div class="image-uploader__item">
          <p class="image-uploader__item-name">Мобильная версия (горизонтальная версия, 480x560 px)</p>
          <div class="card flex justify-content-center">
            <FileUpload
              mode="basic"
              name="file"
              :url="`${envUrlBase}/api/Banner/LoadImage/5`" accept="image/*"
              @before-send="authToken"
              :auto="false"
              chooseLabel="Добавить"
            />
          </div>
        </div>
        <div class="image-uploader__buttons">
          <BaseBtn
            text="Сохранить"
            @clickBtn="saveBanners"
          />
          <BaseBtn
            text="Отменить"
            @clickBtn="clearLoadBanners"
          />
        </div>
      </div>
      <div class="video-uploader" v-if="loaderVideo">
        <InputText
          type="text"
          placeholder="Ссылка"
        />
        <div class="video-uploader__buttons">
          <BaseBtn
            text="Сохранить"
          />
          <BaseBtn
            text="Отменить"
          />
        </div>
      </div>
    </BaseModalWindow>
  </LayoutDefault>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import router from '@/router'

import draggable from 'vuedraggable'

import BaseModalWindow from '@/components/modals/BaseModalWindow'
import LayoutDefault from '@/layout/LayoutDefault'
import BannerUploaderItem from '@/components/elements/BannerUploaderItem'

import BaseBtn from '@/components/ui/BaseBtn'

import ToolbarIcons from '@/components/icons/ToolbarIcons'

import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import FileUpload from 'primevue/fileupload'

export default {
  name: 'BannerEditorView',
  components: {
    draggable,
    LayoutDefault,
    BannerUploaderItem,
    ToolbarIcons,
    BaseBtn,
    InputText,
    Textarea,
    BaseModalWindow,
    FileUpload
  },
  props: {
  },
  setup () {
    const store = useStore()
    const currentBanner = ref('')
    const currentId = ref(0)
    const title = ref('')
    const description = ref('')
    const link = ref('')
    const visibleDescriptionPrewiew = ref(false)
    const visibleItems = ref(false)
    const loaderVideo = ref(false)
    const envUrlBase = process.env.VUE_APP_URL_EDUCATION

    onMounted(() => {
      store.dispatch('setMainBannersEducationData')
    })

    const bannersData = computed(() => {
      return store.getters.getMainBannersEducationData
    })

    const openCloseLoader = (val) => {
      store.commit('SetShowLoaderBanners', val)
    }

    const clearLoadBanners = () => {
      store.dispatch('setClearLoadBannersEducation')
      store.commit('SetShowLoaderBanners', false)
    }

    const saveBanners = () => {
      store.dispatch('setSaveBannersEducation')
      store.commit('SetShowLoaderBanners', false)
    }

    const deleteBanner = (id) => {
      store.dispatch('setDeleteBannerEducation', id)
    }

    const showItems = () => {
      visibleItems.value = !visibleItems.value
    }

    const saveForms = () => {
      store.dispatch('setMoveBannersEducation')
    }

    const closeBannersEditor = () => {
      router.push('/modules')
    }

    const showLoaderBanners = computed(() => store.getters.getShowLoaderBanners)

    const getCurrentBanner = (urlBanner) => {
      currentBanner.value = urlBanner.BannerFiles[0].FilePath
      currentId.value = urlBanner.Id
      title.value = urlBanner.Header
      description.value = urlBanner.Description
      link.value = urlBanner.Link
    }

    const showDescriptionPrewiew = () => {
      if (title.value !== '' || description.value !== '') {
        visibleDescriptionPrewiew.value = true
      } else {
        visibleDescriptionPrewiew.value = false
      }
    }
    const authToken = (e) => {
      e.xhr.setRequestHeader('Authorization', `Bearer ${localStorage.token || sessionStorage.token}`)
    }

    const moveBanners = (evn) => {
      store.commit('SetMoveBannersEducation', evn.moved)
    }

    return {
      bannersData,
      title,
      description,
      link,
      currentBanner,
      envUrlBase,
      getCurrentBanner,
      showDescriptionPrewiew,
      visibleDescriptionPrewiew,
      openCloseLoader,
      clearLoadBanners,
      saveBanners,
      deleteBanner,
      saveForms,
      closeBannersEditor,
      authToken,
      showLoaderBanners,
      visibleItems,
      showItems,
      loaderVideo,
      moveBanners
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 180px;

  &__title {
    font-size: 20px;
    font-weight: 500;
    line-height: 22px;
    text-align: left;
    color: #000000;
  }

  &__list {
    display: flex;
    align-items: center;
    gap: 32px;

    &-item {
      display: flex;
      gap: 32px;
    }
  }

  &__editor {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;

    :deep(.p-inputtext) {
      width: 420px;
      border-radius: 4px;
    }
  }

  &__preview {
    max-width: 839px;
    height: 208px;
    border-radius: 10px
  }
}
.buttons {
  display: flex;
  gap: 30px;
  justify-content: center;
}
.image-uploader {
  display: flex;
  flex-direction: column;
  gap: 25px;

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 30px;
    &:last-child {
      margin-bottom: 80px;
    }

    :deep(.p-button) {
      background-color: #1BA6DA;
      border: none;
      transition: 0.5s;

      &:hover {
        background-color: #1BA6DA;
        opacity: 0.8;
        transition: 0.5s;
      }
    }

    &-name {
      font-size: 16px;
      font-weight: 400;
    }
  }

  &__buttons {
    display: flex;
    gap: 30px;
    justify-content: center;
  }
}
.video-uploader {
  display: flex;
  flex-direction: column;
  gap: 76px;
  padding: 80px 64px 0px 64px;

  :deep(.p-inputtext) {
    width: 420px;
  }

  &__buttons {
    display: flex;
    gap: 30px;
    justify-content: center;
  }
}
.adder {
  display: flex;
  gap: 30px;

  &__items {
    transform: translateX(-350px);
    opacity: 0;
    transition: ease-in 0.5s;

    &_visible {
      opacity: 1;
      transform: translateX(0);
      transition: ease-out 0.5s;
    }
  }
}
</style>
